import { clickable, collection, isPresent } from 'ember-cli-page-object';
import { default as Tab, selector as tabSelector } from './stepper-form/tab.js';

export const selector = '[ data-test-stepper-form ]';
export const bodySelector = '[ data-test-stepper-form-body ]';
export const actionsSelector = '[ data-test-stepper-form-actions ]';
export const previousSelector = '[ data-test-stepper-form-previous ]';

export default (
  scope = selector,
  bodyProperties = {},
  actionProperties = {}
) => ({
  scope,

  tabs: collection(tabSelector, Tab()),
  body: {
    scope: bodySelector,
    ...bodyProperties,
  },

  actions: {
    scope: actionsSelector,
    previousIsPresent: isPresent(previousSelector),
    previous: clickable(previousSelector),
    ...actionProperties,
  },
});
